<template>
  <div>
    <div class="md-layout md-alignment-center" style="margin-bottom: 20px;">
      <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
        <md-card>
          <md-card-header>
            <div class="md-title text-center">送信が完了しました！</div>
            <div class="md-subhead text-center">DMにて詳細なやりとりをしてください</div>
          </md-card-header>
          <md-card-media>
            <img src="https://2.bp.blogspot.com/-wee41YaD6uM/VixBlISIAEI/AAAAAAAA0DQ/6j9d_eaeJ8E/s800/nomikai_happy.png">
          </md-card-media>
        </md-card>
      </div>
    </div>
    <div style="text-align: center; margin: 30px 0 10px;">
      <md-button class="" @click="toMypage">
        <md-icon class="md-size-1x">create</md-icon>
        自分のめしメイシを作る
      </md-button>
    </div>
  </div>
</template>

<script>
import router from '../router'
export default {
  name: 'Tahnks',
  methods: {
    toHome: function () {
      router.push({name: 'Home'})
    },
    toMypage: function () {
      router.push({name: 'Mypage'})
    }
  }
}
</script>

<style lang="sass" scoped>
.text-center
  text-align: center
</style>



// WEBPACK FOOTER //
// src/components/Thanks.vue